export default __webpack_public_path__ + "static/media/phone9.c622edf3.jpg";